import { schemaSystemVariable } from 'cpool-schemas';
import type { z } from 'zod';

export const SystemVariablesTableDefinitionZod = schemaSystemVariable;

export type SystemVariablesTableSchema = z.infer<typeof SystemVariablesTableDefinitionZod>;
